import { Typography, Box } from "@mui/material" 
import FormDescription from '../../../inputFormComponents/FormDescription'

const DescriptionUserEmailText = () => {
  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Verwendung von Variablen:</Typography>
          <Typography variant="body2">Folgende Variable kannst Du in Deinen Email-Vorlagen nutzen:</Typography>
          <Typography variant="body2">_Firmenname = Der in Deinen Benutzerdaten gespeicherte Firmenname.</Typography>
        </Box>,
      ]}
    />
  )
}

export default DescriptionUserEmailText